import { render, staticRenderFns } from "./createproject.vue?vue&type=template&id=227381fc&scoped=true&"
import script from "./createproject.vue?vue&type=script&lang=js&"
export * from "./createproject.vue?vue&type=script&lang=js&"
import style0 from "./createproject.vue?vue&type=style&index=0&id=227381fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227381fc",
  null
  
)

export default component.exports